import { memo } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
const LoadingSpinner = memo(({ 
  fullScreen = false, 
  message = 'Loading...', 
  size = 40,
  color = 'primary'
}) => {
  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        ...(fullScreen && {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          zIndex: 9999,
        }),
        ...(!fullScreen && {
          padding: 3,
        }),
      }}
      role="status"
      aria-label={message}
    >
      <CircularProgress 
        size={size} 
        color={color}
        aria-label="Loading indicator"
      />
      {message && (
        <Typography 
          variant="body2" 
          color="text.secondary"
          sx={{ textAlign: 'center' }}
        >
          {message}
        </Typography>
      )}
    </Box>
  );
  return content;
});
export default LoadingSpinner; 